<template>
  <div class="list-item-component">
    <router-link :to="`https://m.youthmba.com/project/${item.id}`"
                 class="list-item-component"
                 v-ym-report:MARKETING_2021READINGDAY_PROJECT_JOIN_CLICK="{ id: item.id }"
    >
      <ym-img class="list-item-component-cover"
              :src="item.cover"
      />
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'ProjectItem',
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {};
    },
    methods: {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .list-item-component {
    display: flex;
    margin-bottom: 70px;
    &:last-child {
      margin-bottom: 0;
    }
    &-cover {
      width: 730px;
      height: 630px;
      margin-left: 10px;
      border-radius: 20px;
    }
  }
</style>
